import React from 'react'
import { css } from 'emotion'
import { Icon } from 'semantic-ui-react'

export const styles = {}
styles.container = css`
  margin-top: 12px;
  padding-top: 12px;
  color: #494c4f;
  a {
    color: #4c5b69;
  }
`

export const LicenseFooter = () => (
  <div className={styles.container}>
    {/* <a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/">
      <img
        alt="Creative Commons License"
        style={{ borderWidth: 0 }}
        src="https://i.creativecommons.org/l/by-nc-nd/4.0/88x31.png"
      />
    </a>
    <br /> */}
    <Icon name="creative commons" />
    <span
      {...{ 'xmlns:dct': 'http://purl.org/dc/terms/' }}
      property="dct:title"
    >
      Esmer Games Blog
    </span>
    &nbsp;by&nbsp;
    <a
      {...{ 'xmlns:cc': 'http://creativecommons.org/ns#' }}
      href="https://github.com/sigmasoldi3r"
      property="cc:attributionName"
      rel="cc:attributionURL"
    >
      Pablo Blanco Celdrán
    </a>
    &nbsp;is licensed under a&nbsp;
    <a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/">
      Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
      License
    </a>
    .
  </div>
)
